import ContactSection from '../../components/home/ContactSection'

export default function ContactPage() {
  return (
    <div className="pt-8">
      <ContactSection isContactPage />
    </div>
  )
}
